/**
 * Nudge API class
 * Handles all nudge-related API calls (actions taken timeline)
 */

import { BaseApi } from './base.api';
import { LOS_API_BASE_URL, ENVIRONMENT } from '@/config';
import type {
    GetActionsTakenRequest,
    GetActionsTakenResponse,
} from '@/types/nudge.types';

export class NudgeApi extends BaseApi {
    constructor() {
        super(LOS_API_BASE_URL);
    }

    async getActionsTaken(request: GetActionsTakenRequest): Promise<GetActionsTakenResponse> {
        try {
            const response = await this.post<GetActionsTakenResponse>(
                `/nudge/actions-taken`,
                { loan_id: request.loan_id },
                true
            );

            if (response.success && response.data) {
                return response.data;
            }

            return {
                status: 'Error',
                message: response.message || 'Failed to fetch actions taken',
                error: response.message || '',
                response: { loan_id: request.loan_id, total_events: 0, timeline: [] },
            };
        } catch (error) {
            const apiError = this.handleError(error);
            return {
                status: 'Error',
                message: apiError.message || 'Failed to fetch actions taken. Please try again.',
                error: apiError.message || '',
                response: { loan_id: request.loan_id, total_events: 0, timeline: [] },
            };
        }
    }
}

// Singleton instance
export const nudgeApi = new NudgeApi();
